<template>
    <div class="modal right fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="sidemenu-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-body" @click="close">
                    <div class="menu-close">
                        <a href="#" @click.prevent="close">
                            &times;
                        </a>
                    </div>
                    <div class="input-group my-2 d-sm-flex d-md-none" @click.stop="">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="fas fa-search"></i>
                            </span>
                        </div>
                        <input type="search" class="form-control form-control-sm" v-model="keywords" placeholder="書籍検索" @keydown.enter="search" />
                    </div>
                    <template v-if="!$store.state.user">
                        <a class="menu-item" :href="`//www${$store.state.base_domain}/`" v-if="$store.state.subdomain && !$store.state.is_isolated">
                            <i class="fas fa-running"></i>
                            ポータル
                        </a>
                        <a class="menu-item" :href="`//www${$store.state.base_domain}/login`" v-if="!$store.state.is_isolated">
                            <i class="fas fa-sign-in-alt"></i>
                            ログイン
                        </a>
                        <a class="menu-item" :href="`//www${$store.state.base_domain}/register`" v-if="!$store.state.is_isolated">
                            <i class="fas fa-user-plus"></i>
                            ユーザー登録
                        </a>
                        <a href="#" @click.prevent="$emit('showLayout')" class="menu-item">
                            <i class="fas fa-palette"></i>
                            テーマ設定
                        </a>
                    </template>
                    <template v-else>
                        <component :is="is(true)" to="/" :href="href('/', true)" class="menu-item" v-if="$store.state.user.subdomain">
                            <i class="fas fa-book"></i>
                            自分の本棚
                        </component>
                        <component :is="is()" to="/mypage" :href="href('/mypage')" class="menu-item">
                            <i class="fas fa-home"></i>
                            マイページ
                        </component>
                        <component :is="is()" to="/" :href="href('/')" class="menu-item">
                            <i class="fas fa-running"></i>
                            ポータル
                        </component>
                        <a href="#" @click.prevent="$emit('showLayout')" class="menu-item">
                            <i class="fas fa-palette"></i>
                            テーマ設定
                        </a>
                        <div class="menu-divider"></div>
                        <component :is="is()" :to="recentTo" :href="recentHref" class="menu-item active" v-if="hasRecent">
                            <i class="fas fa-pen-fancy"></i>
                            「{{$store.state.recent.section_name || '(無題)'}}」の編集
                        </component>
                        <component :is="is()" to="/mypage/books" :href="href('/mypage/books')" class="menu-item">
                            小説
                        </component>
                        <component :is="is()" to="/mypage/articles" :href="href('/mypage/articles')" class="menu-item">
                            記事
                        </component>
                        <component :is="is()" to="/mypage/notes" :href="href('/mypage/notes')" class="menu-item">
                            ノート一覧
                        </component>
                        <component :is="is()" to="/mypage/account" :href="href('/mypage/account')" class="menu-item">
                            アカウント情報
                        </component>
                        <component :is="is()" to="/mypage/favorites" :href="href('/mypage/favorites')" class="menu-item">
                            お気に入り
                        </component>
                        <component :is="is()" to="/mypage/reviews/received" :href="href('/mypage/reviews/received')" class="menu-item">
                            受け取った感想
                        </component>
                        <component :is="is()" to="/mypage/reviews/sent" :href="href('/mypage/reviews/sent')" class="menu-item">
                            投稿した感想
                        </component>
                        <component :is="is()" to="/mypage/histories" :href="href('/mypage/histories')" class="menu-item">
                            履歴
                        </component>
                        <component :is="is()" to="/mypage/followees" :href="href('/mypage/followees')" class="menu-item">
                            フォロー
                        </component>
                        <component :is="is()" to="/mypage/tickets" :href="href('/mypage/tickets')" class="menu-item" @click="close">
                            お問い合わせ
                        </component>
                        <component :is="is()" to="/mypage/notices" :href="href('/mypage/notices')" class="menu-item" @click="close">
                            お知らせ
                        </component>
                        <div class="menu-divider"></div>
                        <a class="menu-item" href="#" @click.prevent="logout()">
                            <span v-if="$store.getters.isGuest">
                                <i class="fas fa-times"></i>
                                登録削除
                            </span>
                            <span v-else>
                                ログアウト
                            </span>
                        </a>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.modal.right {
    .modal-dialog {
        position: fixed;
        margin: auto;
        width: 320px;
        height: 100%;
        transform: translate3d(0%, 0, 0);
    }
    .modal-content {
        height: 100%;
        overflow-y: auto;
    }
    .modal-content {
        border-radius: 0;
        border: none;
    }
    &.fade {
        .modal-dialog {
            right: -320px;
            transition: opacity 0.2s linear, right 0.2s ease-out;
            .modal-body {
                padding: 0;
            }
        }
        &.show .modal-dialog {
            right: 0;
        }
    }
}
.menu-item {
    display: block;
    padding: .5rem 1rem;
    color: #222;
    &.active {
        border-top: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        font-weight: bold;
    }
    &:hover {
        text-decoration: none;
        background-color: #eee;
    }
}
// 色テーマ
.b-black {
    background-color: #333;
    .menu-item {
        color: snow;
        &:hover {
            background-color: #777;
        }
    }
}
.b-zouge {
    background-color: #f8f4e6;
    .menu-item {
        color: #222;
        &:hover {
            background-color: #e4e0d1;
        }
    }
}
.b-sakura {
    background-color: #fef4f4;
    .menu-item {
        color: #222;
        &:hover {
            background-color: #ebe0e0;
        }
    }
}
.menu-divider {
    width: 100%;
    border-top: 1px solid #eee;
    margin: .5rem 0;
}
.menu-close {
    font-size: 3rem;
    text-align: right;
    padding: 0 .5rem;
    margin: -1rem 0 -1.5rem;
    a {
        color: #999;
        &:hover {
            color: #222;
            text-decoration: none;
        }
    }
}
</style>

<script>
export default {
    props: {
        isClosed: {
            default: true,
        }
    },
    data() {
        return {
            keywords: "",
        }
    },
    methods: {
        search(ev) {
            if (ev.keyCode !== 13) return;
            if (!this.keywords.length) return;
            this.$router.push("/search?keywords=" + encodeURI(this.keywords));
            this.close();
        },
        logout() {
            const logout = () => {
                axios.post("/logout").then(res => {
                    this.user = {};
                    this.$store.commit("logout");
                    if (! this.$store.state.subdomain) {
                        location.href = `//www${this.$store.state.base_domain}/`;
                    }
                });
            };
            if (this.$store.getters.isGuest) {
                Swal.fire({
                    title: "登録削除",
                    html: `登録を削除すると、全てのデータが削除されます。
                    <div class="small text-success text-left">
                        投稿データを削除したくない場合は、
                        正規登録を行ってください。
                        正規登録は簡単です。
                    </div>`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "登録削除する",
                    cancelButtonText: "キャンセル",
                    confirmButtonColor: "crimson",
                    cancelButtonColor: "gray",
                    reverseButtons: true,
                }).then(confirm => {
                    if (confirm.isConfirmed) {
                        logout();
                    }
                });
            } else {
                logout();
            }
        },
        close() {
            $("#sidemenu-modal").modal("hide");
        },
        is(is_hondana = false) {
            if (!is_hondana) {
                if (this.isPortal) {
                    return "router-link";
                }
                return "a";
            } else {
                if (this.isMyShelf) {
                    return "router-link";
                }
                return "a";
            }
        },
        href(path, is_hondana = false) {
            if (!is_hondana) {
                if (!this.isPortal) {
                    return "//www" + this.$store.state.base_domain + path;
                }
                return "";
            } else {
                if (this.isPortal || !this.isMyShelf) {
                    return "//" + this.$store.state.user.subdomain + this.$store.state.base_domain + path;
                }
                return "";
            }
        },
    },
    computed: {
        // ポータルにいるか
        isPortal() {
            if (document.domain.split(".")[0] === "www") {
                return true;
            }
            return false;
        },
        // 自分の本棚にいるか
        isMyShelf() {
            if (document.domain.split(".")[0] === this.$store.state?.user?.subdomain) {
                return true;
            }
            return false;
        },
        themeColor() {
            if (this.$route.path.match(/^\/author\/page\/\d+\/section/)) {
                return this.$store.state.background_color;
            }
            return "white";
        },
        hasRecent() {
            if (this.$store.state.recent) {
                return true;
            }
            return false;
        },
        recentTo() {
            if (this.hasRecent) {
                const recent = this.$store.state.recent;
                return `/mypage/book/${recent.book_id}/section/edit/${recent.id}`;
            }
            return "";
        },
        recentHref() {
            return this.href(this.recentTo);
        }
    },
    mounted() {
        this.$store.dispatch("recent");
    }
}
</script>